// extracted by mini-css-extract-plugin
module.exports = {"section":"ATS_section__KMJuH"};